<div class="column sets" *ngIf="score && score.currentlyServing">
    <div class="cell"><span class="serving-indicator" *ngIf="score.currentlyServing === 1"></span></div>
    <div class="cell"><span class="serving-indicator" *ngIf="score.currentlyServing === 2"></span></div>
</div>
<div class="column sets" *ngIf="innings">
    <div class="cell">
        <div *ngIf="innings.team1.runs >= 0; else noScoreTemplate">{{ innings.team1.runs }}/{{ innings.team1.wickets }}</div>
    </div>
    <div class="cell">
        <div *ngIf="innings.team2.runs >= 0; else noScoreTemplate">{{ innings.team2.runs }}/{{ innings.team2.wickets }}</div>
    </div>
</div>
<ng-template #noScoreTemplate> - </ng-template>
